module.exports = __webpack_public_path__ + "img/about_roomcast_2.6b8922df.png";